angular.module('employeeAdd', ['ngRoute', 'ngResource', 'core', 'core.auth', 'core.env', 'pascalprecht.translate', 'uiGmapgoogle-maps']);



// WEBPACK FOOTER //
// ./src/app/employee/employee-add/employee-add.module.js